import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { darkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Feil epost eller passord');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy-900 dark:bg-dark-400 flex items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <button
          onClick={toggleTheme}
          className="text-cream-200 hover:text-white transition-colors text-xl"
        >
          {darkMode ? '☀️' : '🌙'}
        </button>
      </div>

      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold text-white tracking-widest">PODIUM</h1>
          <p className="text-gold-500 mt-2 text-sm font-medium tracking-wide uppercase">Konferanseverktøy</p>
        </div>

        <div className="bg-white dark:bg-dark-50 rounded-2xl shadow-2xl p-8">
          {error && (
            <div className="bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 p-3 rounded-lg mb-6 text-sm border border-red-200 dark:border-red-800">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-navy-700 dark:text-cream-200 text-sm font-medium mb-1">
                Epost
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input dark:bg-dark-100 dark:border-dark-50 dark:text-cream-100"
                placeholder="din@epost.no"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-navy-700 dark:text-cream-200 text-sm font-medium mb-1">
                Passord
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input dark:bg-dark-100 dark:border-dark-50 dark:text-cream-100"
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-navy-700 dark:bg-gold-500 text-white dark:text-navy-900 py-3 rounded-xl font-semibold hover:bg-navy-800 dark:hover:bg-gold-600 transition-all disabled:opacity-50"
            >
              {loading ? 'Logger inn...' : 'Logg inn'}
            </button>
          </form>
        </div>

        <p className="text-center text-navy-400 text-xs mt-6">
          © 2026 Podium · Profesjonelt konferanseverktøy
        </p>
      </div>
    </div>
  );
};

export default Login;
